<template>
    <form class="info-event-form form grid" :action="content.url" method="post">
        <div class="form--fieldset-row" v-if="!isCsrfCookieSet">
            <div class="form--fieldset">
                <div class="general-error" v-text="content.no_cookie_message">
                </div>
            </div>
        </div>

        <div class="form--fieldset-row">
            <fieldset class="form--fieldset"
                    v-for="(fieldset, fieldsetIdx) in protectedFieldsets" :key="fieldsetIdx">
                <div class="grid--row form--legend-row">
                    <div class="grid--col form--legend">
                        <div class="form--fieldset-title">
                            <legend v-text="fieldset.name"></legend>
                        </div>
                    </div>
                    <div class="grid--col form--fields">
                        <div class="form--field-row">
                            <component :is="field.component"
                                    v-for="(field, fieldIdx) in fieldset.fields" :key="field.id"
                                    class="form--field"
                                    :class="bemAdd(field.field_facet, 'field')"
                                    @recaptcha-submit="handleFormSubmit"
                                    :disclaimer="content.disclaimer"
                                    v-model="field.val"
                                    v-bind="bindFieldData(field)">
                            </component>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <!-- <pre v-if="content" v-text="content"></pre> -->
    </form>
</template>

<script>
    import cookie from 'util/dom/cookie';
    import formMixin from 'vue/mixins/form/form';


    const DEBUG = globals.config.debug;


    const BASIC_FORM_FIELDS = [
        'cmp-form-field-bool',
        'cmp-form-field-input',
        'cmp-form-field-textarea',
        'cmp-form-field-select',
    ];

    const FLOATING_LABEL_FORM_FIELDS = [
        'cmp-form-field-input',
        'cmp-form-field-textarea',
    ];

    const FILTER_FORM_FIELDS = [
        'cmp-form-field-filter',
    ];

    const SUBMIT_FORM_FIELDS = [
        'cmp-form-submit',
    ];


    export default {
        mixins: [
            formMixin,
        ],
        computed: {
            isCsrfCookieSet() {
                return (cookie.read('csrftoken') || '').length;
            },
        },
        methods: {
            bindFieldData(field) {
                const isControlField = !!field.control_id || !!field.controlled_by;
                const isBasicFormField = BASIC_FORM_FIELDS.includes(field.component);
                const isFilterFormField = FILTER_FORM_FIELDS.includes(field.component);
                const isSubmitButton = SUBMIT_FORM_FIELDS.includes(field.component);
                const hasFloatingLabel = FLOATING_LABEL_FORM_FIELDS.includes(field.component);
                const { placeholder, type, label, items, id, state, messages, pattern } = field;
                let result = {};

                switch (true) {
                    case isControlField:
                        result = {
                            field,
                            controlId: field.control_id,
                            controlledBy: field.controlled_by,
                            controlBehaviour: field.control_behaviour,
                            controlComponent: field.control_component,
                        };
                        break;
                    case isBasicFormField:
                        result = { hasFloatingLabel, placeholder, type, label, items, id, state, messages, pattern };
                        break;
                    case isFilterFormField:
                        DEBUG && console.log(`[components/sib-form] - Received '${ field.id }' with prefilled value '${ field.val }'`);

                        result = {
                            field,
                            filterId: field.filter_id,
                            filteredBy: field.filtered_by,
                            filterBehaviour: field.filter_behaviour,
                        };
                        break;
                    case isSubmitButton:
                        result = {
                            label,
                            isSubmitting: this.isSubmitting,
                            sitekey: field.recaptcha_sitekey,
                            generalErrors: this.generalErrors,
                        };
                        break;
                    default:
                        break;
                }

                return result;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?ec555806